import useHttpPost from "./useHttpPost";

function usePostTransaction(target) {
  return useHttpPost("quicklink", "post", {}, target);
}

export default usePostTransaction;
